(function (root) {
  'use strict';
  function node(tag, text, className) {
    var result = document.createElement(tag);
    if (text != null) result.textContent = text;
    if (className) result.className = className;
    return result;
  }
  function button(text, action, className) {
    var result = node('button', text, className || 'fb-reminders-text-action');
    result.type = 'button'; result.addEventListener('click', action); return result;
  }
  function field(form, label, control) {
    var wrapper = node('label', label);
    wrapper.appendChild(control); form.appendChild(wrapper); return control;
  }
  function mount(container, api, person) {
    if (!container || !person.id) return;
    var generation = (container._detailsGeneration || 0) + 1;
    container._detailsGeneration = generation;
    var current, pending = false, preferences, privateIdeas;
    var path = '/friends/' + encodeURIComponent(person.id) + '/details';
    var alive = function () { return container._detailsGeneration === generation; };
    document.addEventListener('fb-private-ideas:updated', function (event) { if (alive() && privateIdeas && event.detail && event.detail.friendId === person.id) privateIdeas.refresh(); });
    async function load() {
      container.textContent = '';
      container.appendChild(node('p', 'Loading saved details…', 'fb-reminders-status'));
      try {
        var response = await api.request(path);
        if (!alive()) return;
        current = response.details; render();
      } catch (_) {
        if (!alive()) return;
        container.textContent = '';
        container.appendChild(node('p', 'We couldn’t load the saved details.'));
        container.appendChild(button('Try again', load));
      }
    }
    function render(focusKind) {
      var columns = container.querySelector('.fb-person-details__columns');
      if (!focusKind || !columns) {
        container.textContent = '';
        container.appendChild(node('h2', 'Good to remember about ' + person.name));
        container.appendChild(node('p', 'Saved for this person, across all their occasions.', 'fb-person-details__intro'));
        columns = node('div', null, 'fb-person-details__columns');
        container.appendChild(columns);
        if (root.FBPersonPreferences) {
          var preferenceMount = node('div'); container.appendChild(preferenceMount);
          preferences = root.FBPersonPreferences.mount(preferenceMount, api, { path: '/friends/' + encodeURIComponent(person.id) + '/preferences', source: 'sender', title: 'Likes and avoidances', visibility: 'Your notes stay private. Details they supplied can only be changed by them.', onSaved: function () { if (!api.announcesRecipientMutations) document.dispatchEvent(new root.CustomEvent('fb-recipient-preferences:updated', { detail: { friendId: person.id } })); } });
        }
        if (root.FBWishlistIntent) { var ideas = node('div'); container.appendChild(ideas); privateIdeas = root.FBWishlistIntent.mountPrivate(ideas, api, person.id); }
      }
      ['notes', 'address'].forEach(function (kind) {
        if (focusKind && kind !== focusKind) return;
        // An open editor retains both its draft and the version it was based on.
        var original = current, conflicted = false, comparing = false;
        var card = node('details', null, 'fb-person-details__card');
        card.setAttribute('data-person-card', kind);
        var previous = columns.querySelector('[data-person-card="' + kind + '"]');
        card.open = !!(previous && previous.open);
        if (previous) columns.replaceChild(card, previous); else columns.appendChild(card);
        var heading = node('summary', null, 'fb-person-details__toggle');
        heading.appendChild(node('h3', kind === 'notes' ? 'Your private notes' : 'Saved delivery address'));
        card.appendChild(heading);
        var content = node('div', null, 'fb-person-details__content');
        card.appendChild(content);
        var summary = node('p', '', 'fb-person-details__summary');
        if (kind === 'notes') summary.textContent = current.notes.text || 'Keep useful details here: pets, school rules, or what you sent last time.';
        else {
          var a = current.address;
          summary.textContent = [[a.line1, a.line2].filter(Boolean).join(', '), [a.suburb, a.state, a.postcode].filter(Boolean).join(' '), a.phone].filter(Boolean).join('\n') || 'No address saved yet. Add what you know, or ask them to confirm it.';
        }
        content.appendChild(summary);
        content.appendChild(node('p', kind === 'notes' ? 'Only you can see these notes. They are never included in a link you share.' : current.addressConfirmedAt ? 'Confirmed by them. Check it is still current before sending.' : 'Not confirmed by them. Check before sending.', 'fb-person-details__hint'));
        var form = node('form', null, 'fb-person-details__form'); form.hidden = true;
        var edit = button(kind === 'notes' ? 'Edit private notes' : 'Change address', function () {
          form.hidden = false; edit.hidden = true; form.querySelector('textarea, input').focus();
        });
        edit.setAttribute('aria-expanded', 'false');
        var formId = 'person-' + person.id + '-' + kind;
        form.id = formId; edit.setAttribute('aria-controls', formId);
        edit.addEventListener('click', function () { edit.setAttribute('aria-expanded', 'true'); });
        content.appendChild(edit);
        if (kind === 'address' && person.askAddress) content.appendChild(button('Ask them to confirm', person.askAddress));
        content.appendChild(form);
        var fields = node('fieldset'); form.appendChild(fields);
        var inputs = {};
        if (kind === 'notes') {
          var text = node('textarea'); text.rows = 5; text.maxLength = 4000; text.value = current.notes.text;
          /* Shopify Customer Events (monorail, app/custom pixels) skip anything inside [data-shopify-privacy="exclude"]. */
          text.setAttribute('data-shopify-privacy', 'exclude'); fields.setAttribute('data-shopify-privacy', 'exclude');
          inputs.text = field(fields, 'Notes about ' + person.name, text);
        } else {
          [['line1', 'Street address'], ['line2', 'Apartment, unit, etc. (optional)'], ['suburb', 'Suburb'], ['state', 'State'], ['postcode', 'Postcode'], ['phone', 'Phone (optional)']].forEach(function (entry) {
            var key = entry[0], input;
            if (key === 'state') {
              input = node('select');
              ['', 'VIC', 'NSW', 'QLD', 'SA', 'WA', 'TAS', 'ACT', 'NT'].forEach(function (value) {
                var option = node('option', value || 'Choose a state'); option.value = value; input.appendChild(option);
              });
            } else {
              input = node('input'); input.type = key === 'phone' ? 'tel' : 'text';
              input.maxLength = key === 'postcode' ? 4 : key === 'phone' ? 24 : 120;
              if (key === 'postcode') { input.inputMode = 'numeric'; input.pattern = '[0-9]{4}'; }
            }
            input.value = current.address[key] || ''; inputs[key] = field(fields, entry[1], input);
          });
        }
        var save = node('button', kind === 'notes' ? 'Save note and review details' : 'Save address', 'button'); save.type = 'submit'; fields.appendChild(save);
        fields.appendChild(button('Cancel', function () { render(kind); }));
        var status = node('p', '', 'fb-reminders-status'); status.setAttribute('role', 'status'); form.appendChild(status);
        var latestPanel = node('div'); form.appendChild(latestPanel);
        var reload = button('Compare with latest details', async function () {
          if (pending || comparing) return; comparing = true; reload.disabled = true;
          try {
            var response = await api.request(path);
            if (!alive()) return;
            latestPanel.textContent = '';
            latestPanel.appendChild(node('p', 'Your draft: ' + (kind === 'notes' ? inputs.text.value : Object.keys(inputs).map(function (key) { return inputs[key].value; }).join(', '))));
            latestPanel.appendChild(node('p', 'Latest saved: ' + (kind === 'notes' ? response.details.notes.text : Object.values(response.details.address).filter(Boolean).join(', '))));
            latestPanel.appendChild(button('Edit latest details', function () {
              var draftCopy = kind === 'notes' ? inputs.text.value : Object.keys(inputs).map(function (key) { return inputs[key].value; }).join(', ');
              current = response.details; render(kind);
              columns.querySelector('[data-person-card="' + kind + '"] .fb-person-details__content').appendChild(node('p', 'Your previous draft: ' + draftCopy));
            }));
          } catch (_) { status.textContent = 'We couldn’t reload the details. Your draft is still here.'; }
          finally { comparing = false; reload.disabled = false; }
        }); reload.hidden = true; form.appendChild(reload);
        form.addEventListener('submit', async function (event) {
          event.preventDefault();
          if (pending || comparing || conflicted) return;
          pending = true; fields.disabled = true; status.textContent = 'Saving…'; reload.hidden = true;
          var body;
          if (kind === 'notes') body = { notes: { text: inputs.text.value, version: original.notes.version } };
          else {
            var address = {};
            Object.keys(inputs).forEach(function (key) { address[key] = inputs[key].value; });
            body = { address: address, addressVersion: original.addressVersion };
          }
          try {
            var response = await api.request(path, { method: 'PATCH', body: body });
            if (!alive()) return;
            current = response.details; render(kind);
            if (kind === 'notes' && preferences) preferences.refresh();
            if (!api.announcesRecipientMutations && typeof root.CustomEvent === 'function') document.dispatchEvent(new root.CustomEvent('fb-recipient-preferences:updated', { detail: { friendId: person.id } }));
            var success = node('p', 'Saved.', 'fb-reminders-status'); success.setAttribute('role', 'status'); columns.querySelector('[data-person-card="' + kind + '"] .fb-person-details__content').appendChild(success);
          } catch (error) {
            if (!alive()) return;
            conflicted = true; reload.hidden = false;
            if (kind === 'notes' && preferences) preferences.refresh();
            if (error && (error.code === 'EDIT_CONFLICT' || error.payload && error.payload.error && error.payload.error.code === 'EDIT_CONFLICT')) {
              status.textContent = 'These details changed in another tab. Your draft is still here. Compare with the latest details before saving again.';
              reload.hidden = false;
            } else status.textContent = error && error.code === 'UNAUTHENTICATED' ? 'Please sign in again. Your draft is still here to copy.' : 'We couldn’t confirm the save. Your draft is still here. Compare the latest details before trying again.';
          } finally { pending = false; fields.disabled = false; save.disabled = conflicted; }
        });
        if (focusKind === kind) (card.open ? edit : heading).focus();
      });
    }
    load();
  }
  root.FBPersonDetails = { mount: mount };
})(window);
